import React, { useEffect, useState } from 'react';
import { ResponseError } from 'services/api/base';
import ActionButton from 'components/ActionButton';
import Dialog from 'components/DesignSystem/Dialog';
import DialogBody from 'components/DesignSystem/Dialog/Body';
import DialogFooter from 'components/DesignSystem/Dialog/Footer';
import Button from 'components/DesignSystem/Button';
import { useForgotPasswordMutation } from 'services/api/auth';
import { useHandleRequestErrors } from 'utils/hooks';
import { isRateLimited, RATE_LIMIT_DEFAULT_MESSAGE } from 'helper/rateLimit';

export default function ResetPasswordButton({
  userId,
  username,
}: {
  userId: number,
  username: string,
}) {
  const [resetPassword, { isLoading, isSuccess, error }] = useForgotPasswordMutation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [rateLimitMessage, setRateLimitMessage] = useState<string | null>(null);

  // Recusa por limite (code 429) vira aviso aqui; só os demais erros vão para /error (issue #1958).
  useHandleRequestErrors(isRateLimited(error) ? undefined : error as ResponseError);

  useEffect(() => {
    if (isSuccess) setDialogOpen(true);
  }, [isSuccess]);

  useEffect(() => {
    if (isRateLimited(error)) setRateLimitMessage(error.description || RATE_LIMIT_DEFAULT_MESSAGE);
  }, [error]);

  return (
    <div className="mx-1 h-100 d-flex align-items-center">
      <Dialog
        open={dialogOpen}
        closeButton
        dismiss={() => setDialogOpen(false)}
        type="success"
      >
        <DialogBody>
          E-mail de recuperação de senha enviado com sucesso.
        </DialogBody>
        <DialogFooter>
          <Button onClick={() => setDialogOpen(false)}>Ok</Button>
        </DialogFooter>
      </Dialog>
      <Dialog
        open={rateLimitMessage !== null}
        closeButton
        dismiss={() => setRateLimitMessage(null)}
        type="error"
      >
        <DialogBody>{rateLimitMessage}</DialogBody>
        <DialogFooter>
          <Button onClick={() => setRateLimitMessage(null)}>Ok</Button>
        </DialogFooter>
      </Dialog>
      <ActionButton
        icon="message"
        loading={isLoading}
        onClick={() => resetPassword({ username })}
        tooltipText="Recuperar senha"
        id={`reset-password-${userId}`}
      />
    </div>
  );
}
